import { Country } from "src/app/services/response-models/countries.response.model";

export class SetCountries {
    public static readonly type = "[App] Load countries";

    constructor(public payload: Country[]) {}
}
